import { scrollToId } from "@/data";

const GROUPS = [
  {
    title: "Explore",
    links: [
      { label: "Why AuraXR", id: "why" },
      { label: "Experience", id: "experience" },
      { label: "Devices", id: "devices" },
    ],
  },
  {
    title: "People",
    links: [
      { label: "For Teachers", id: "teachers" },
      { label: "For Students", id: "students" },
      { label: "For Parents", id: "parents" },
    ],
  },
  {
    title: "Vision",
    links: [
      { label: "Future Classroom", id: "future" },
      { label: "Technology", id: "devices" },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Email", href: "mailto:xraura.ai@gmail.com" },
      { label: "Phone", href: "tel:+917297091197" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/[0.07] bg-[#04060d]">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12 pt-16 pb-10">
        <div className="grid gap-16 lg:grid-cols-[1.3fr_2fr]">
          <div>
            <img
              src="/images/logo-full.png"
              alt="AuraXR"
              data-testid="footer-logo"
              className="h-12 w-auto"
            />
            <p className="mt-6 font-display italic text-xl text-slate-300">
              Making understanding visible.
            </p>
            <p className="mt-6 max-w-sm text-sm text-slate-400 leading-relaxed">
              AuraXR is an emerging education-focused AR concept designed to bring visual and
              spatial learning experiences into the real classroom.
            </p>
            <div className="mt-10 space-y-2 text-sm">
              <a
                data-testid="footer-email"
                href="mailto:xraura.ai@gmail.com"
                className="block text-slate-300 hover:text-[#38BDF8] transition-colors duration-300"
              >
                xraura.ai@gmail.com
              </a>
              <a
                data-testid="footer-phone"
                href="tel:+917297091197"
                className="block text-slate-300 hover:text-[#38BDF8] transition-colors duration-300"
              >
                +91 72970 91197
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-10">
            {GROUPS.map((g) => (
              <div key={g.title}>
                <p className="text-[10px] tracking-[0.35em] uppercase text-slate-500">{g.title}</p>
                <ul className="mt-6 space-y-3.5">
                  {g.links.map((l) => (
                    <li key={l.label}>
                      {l.href ? (
                        <a
                          data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                          href={l.href}
                          className="text-sm text-slate-300 hover:text-[#38BDF8] transition-colors duration-300"
                        >
                          {l.label}
                        </a>
                      ) : (
                        <button
                          data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                          onClick={() => scrollToId(l.id)}
                          className="text-sm text-slate-300 hover:text-[#38BDF8] transition-colors duration-300"
                        >
                          {l.label}
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-24 flex flex-wrap items-center justify-between gap-4 border-t border-white/[0.07] pt-8">
          <span
            data-testid="footer-concept-tag"
            className="rounded-full border border-[#38BDF8]/30 px-4 py-1.5 text-[10px] tracking-[0.3em] uppercase text-[#38BDF8]"
          >
            Concept / Prototype
          </span>
          <p className="text-xs text-slate-500">© 2026 AuraXR. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
